import { Button } from '@mui/material';
import CustomHeader from '../../../core/components/common/custom-header.component';
import Grid from '@mui/material/Grid';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CustomModal from '../../../core/components/ui/custom-modal.component';
import CreateModuleForm from '../components/create-module-form.component';
import PermissionListViewCards from '../components/list-permissions-cards.component';
import { useState } from "react";
import ModuleDetailView from '../components/view-module.component';
import CreateFunctionForm from '../components/create-function-form.component';


const PermissionListViewPage = () => {
    const headerText = "Controlling access to resources and data, ensuring security and privacy."; 

    const [openModal, setOpenModal] = useState(null); 
    const [recordChange, setRecordChange] = useState(false)
    const [isModuleView, setIsModuleView] = useState(false);
    const [selectedModule, setSelectedModule] = useState(null); 

    const handleOpen = (type) => {
        setOpenModal(type);
    };

    const handleClose = () => {
        setOpenModal(null);
    };

    const handleRecordChange = () => setRecordChange(true);

     const handleModuleClick = (module) => {
        setSelectedModule(module); 
        setIsModuleView(true);    
    };

    const handleBackToList = () => {
        setIsModuleView(false);
        setSelectedModule(null); 
    };


    return (
        <div>
            <CustomHeader headerText={headerText} />

            {!isModuleView ? (
                <>
                    <Grid container justifyContent="flex-end">
                        <Button
                            variant="text"
                            startIcon={<AddBoxIcon sx={{ color: '#604CC3' }} />}
                            sx={{ textTransform: 'none' }}
                            onClick={() => handleOpen('module')}
                        >
                            Create Module
                        </Button>
                        <Button
                            variant="text"
                            startIcon={<AddBoxIcon sx={{ color: '#604CC3' }} />}
                            sx={{ textTransform: 'none' }}
                            onClick={() => handleOpen('permission')}
                        >
                            Create Permission
                        </Button>
                    </Grid>
                    <PermissionListViewCards 
                        onModuleClick={handleModuleClick}
                        recordChange={recordChange}  
                        setRecordChange={setRecordChange}
                    />
                </>
            ) : (
                <ModuleDetailView
                    module={selectedModule}
                    onBack={handleBackToList} 
                    handleRecordChange={handleRecordChange}
                />
            )}

            <CustomModal
                open={openModal === 'module'}
                handleClose={handleClose}
                title="Create Module"
                disableEscapeKeyDown={false}
            >
                <CreateModuleForm 
                    handleClose={handleClose} 
                    handleRecordChange={handleRecordChange}
                    setRecordChange={setRecordChange}
                />
            </CustomModal>

            <CustomModal
                open={openModal === 'permission'}
                handleClose={handleClose}
                title="Create Permission"
            >
                <CreateFunctionForm 
                    handleClose={handleClose} 
                    handleRecordChange={handleRecordChange}
                    setRecordChange={setRecordChange}
                />
            </CustomModal>
        </div>
    );
}

export default PermissionListViewPage